var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("title-component"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-sm-12" },
        [
          _c("card-title-component", {
            attrs: { title: _vm.$t("links.immediate-aid-title") }
          }),
          _vm._v(" "),
          _vm._m(0)
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-sm-12" },
        [
          _c("card-title-component", {
            attrs: { title: _vm.$t("links.pension-title") }
          }),
          _vm._v(" "),
          _vm._m(1)
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-sm-12" },
        [
          _c("card-title-component", {
            attrs: { title: _vm.$t("links.advance-decision-title") }
          }),
          _vm._v(" "),
          _vm._m(2)
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-content" }, [
      _c("div", { staticClass: "row" }, [_c("div", { staticClass: "col" })]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _c("div", [
            _vm._v("\n                        Link 1\n                    ")
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v("\n                        Link 2\n                    ")
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v("\n                        Link 3\n                    ")
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-content" }, [
      _c("div", { staticClass: "row" }, [_c("div", { staticClass: "col" })]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _c("div", [
            _vm._v("\n                        Link 1\n                    ")
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v("\n                        Link 2\n                    ")
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v("\n                        Link 3\n                    ")
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-content" }, [
      _c("div", { staticClass: "row" }, [_c("div", { staticClass: "col" })]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _c("div", [
            _vm._v("\n                        Link 1\n                    ")
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v("\n                        Link 2\n                    ")
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v("\n                        Link 3\n                    ")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14e24d18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14e24d18","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LinksComponent.vue
// module id = null
// module chunks = 